import { el } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';

import imageIconString from 'assets/images/image-icon.svg?raw';

import './index.scss';

const imageIcon = stringToSVG(imageIconString);

class InlineImageButton {

  constructor(configuration) {

    this.onImage = configuration.onImage;

    this.el = el('button.inline-image-button', {
      onclick: this.handleClick.bind(this)
    }, [
      imageIcon.cloneNode(true)
    ]);

  }

  async handleClick(event) {

    event.preventDefault();
    event.stopPropagation();

    const result = await application.domUtility.askImageFile();

    if (result.cancelled === true) {
      return;
    }

    this.onImage(result.file);

  }

  update(configuration) {
    this.onImage = configuration.onImage;
  }

}

export default InlineImageButton;